const getters = {
  getParticipantList: (state) => state.participantList,
  getPlanList: (state) => state.planList,
  getOrganizationList: (state) => state.organizationList,
  getEntityList: (state) => state.entityList,
  getInsurerList: (state) => state.insurerList,
  getPolicyList: (state) => state.policyList,

  getParticipant: (state) => state.participant,
  getPlan: (state) => state.plan,
  getBenefitTypes: (state) => state.benefitTypes,
  getOrganization: (state) => state.organization,
  getEntity: (state) => state.entity,
  getInsurer: (state) => state.insurer,
  getPolicy: (state) => state.policy,

  getLogParticipant: (state) => state.log,

  getBulkPolicyTemplate: (state) => state.bulkPolicyTemplate,
};

export default getters;
